const header = document.querySelector('header');
const body = document.querySelector('body');
let scrollPos = 0;
const scrollPosHidden = 200;
const scrollSpySticky = document.getElementById('scrollspy-sticky');
const scrollSpy = document.getElementById('scrollspy');
const jobScrollSpy = document.getElementById('scrollspy-sticky-job');

/**
 * Calculate if the users scroll position is at end of the page
 */
function calculateScrollPosition(scrollPosY) {
    const docRef = document.documentElement;
    const offset = docRef.scrollTop + window.innerHeight;
    const height = docRef.offsetHeight;

    if (offset >= height) {
        return true;
    } else {
        return false;
    }
}

/**
 * Sets the different states of the sticky menu
 */
function handleStickyHeader() {
    const windowY = window.scrollY;

    // Check if menu should be sticky
    if (windowY > 0) {
        body.classList.add('is-sticky');
        header.classList.add('sticky');
    } else {
        body.classList.remove('is-sticky');
        header.classList.remove('sticky');
    }

    // Check if menu must be hidden
    if (windowY >= scrollPosHidden && !calculateScrollPosition(windowY) && !body.classList.contains('open-search')) {
        body.classList.add('hidden');
        header.classList.add('hidden');
    } else {
        body.classList.remove('hidden');
        header.classList.remove('hidden');
    }

    // If user scroll up > show menu
    if (windowY < scrollPos) {
        body.classList.remove('hidden');
        header.classList.remove('hidden');
    }

    scrollPos = windowY;
}

/**
* Sets the stickiness of the scrollspy container
*/
function handleScrollspySticky() {
    if (scrollSpy != null) {
        if (scrollSpy.getBoundingClientRect().top < -73) {
            scrollSpySticky.classList.add('sticky');
        }

        if (scrollSpy.getBoundingClientRect().top > -73) {
            scrollSpySticky.classList.remove('sticky');
        }
    }
}

/**
* Sets the stickiness of the scrollspy container Job
*/
function handleJobScrollspySticky() {
    if (jobScrollSpy != null) {
        const windowY = window.scrollY;
        // Check if menu should be sticky
        if (windowY > 100) {
            jobScrollSpy.classList.add('sticky');
        } else {
            jobScrollSpy.classList.remove('sticky');
        }
    }
}

export { handleStickyHeader, handleScrollspySticky, handleJobScrollspySticky };
